import { render } from "./End.vue?vue&type=template&id=6bc06d02&ts=true&lang=pug"
import script from "./End.vue?vue&type=script&lang=ts"
export * from "./End.vue?vue&type=script&lang=ts"

import "./End.vue?vue&type=style&index=0&id=6bc06d02&lang=scss"

import exportComponent from "/Users/olimago/Documents/www/escape-if-you-can-01/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__